import { render, staticRenderFns } from "./SaveRecurringTaskModal.vue?vue&type=template&id=5c63eeb8&lang=pug"
import script from "./SaveRecurringTaskModal.vue?vue&type=script&lang=js"
export * from "./SaveRecurringTaskModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports